import React from 'react'

import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import BasicLgyInputField from 'app/components/util/lgy-input-field/BasicLgyInputField'
import LgyFileUpload from 'app/components/util/lgy-file-upload/LgyFileUpload'
import '../../style/document-upload-section.scss'

const DocumentsUploadSection = ({ isUploadingDisabled, handleInvalid, handleChange, invalidMessage, correspondence, assignmentDetails,
  revisionComments, appraisalReport, appraisalReportRef }) =>
  <LgySubsection header='Documents Upload' className='documents-upload'>
    <div className='documents-upload-note'>In the event of an upload failure, the system will automatically retry up to 5 times.</div>
    <fieldset id='documents-upload' disabled={isUploadingDisabled}>
      <legend className='usa-sr-only'>Upload Appraisal Report and/or Sales Contract</legend>
      <div className={invalidMessage.some(error => error?.toLowerCase().includes('appraisal report')) ? 'usa-input-error' : ''}>
        <label htmlFor='appraisalReport'>Appraisal Report</label>
        <button
          id='appraisalReport'
          name='appraisalReport'
          type='button'
          ref={appraisalReportRef}>Choose File</button><span>{appraisalReport ? appraisalReport : 'No file selected'}</span>
        {invalidMessage.some(error => error?.toLowerCase().includes('appraisal report')) &&
          <span className='usa-input-error-message' id='appraisalReport-error' role='alert'>{invalidMessage.find(error => error?.toLowerCase().includes('appraisal report'))}</span>}
      </div>
      {correspondence.some(c => c.appraisalDocumentTypeId === '1') &&
        <BasicLgyInputField
          id='revisionComments'
          name='revisionComments'
          label='Revision Comments'
          type='text'
          maxLength={1000}
          onChange={handleChange}
          required={appraisalReport}
          onInvalid={handleInvalid}
          error={invalidMessage.some(error => error.includes('Revision Comments')) ? 'Required' : undefined}
          value={revisionComments} />}
      {assignmentDetails.salePrice && (assignmentDetails.appraisalCode === 'LAPP' || assignmentDetails.appraisalCode === 'IND') &&
        <LgyFileUpload form='appraisalSalesContractUpload'/>
        }
    </fieldset>
  </LgySubsection>

export default DocumentsUploadSection